import React from 'react';
import * as FjPrimitives from 'components/primitives';
import { AlertMessage, Modal } from 'components/styled-primitives';

interface FormErrorsModalProps {
  errorMessageArray?: string[];
  title?: React.ReactNode;
  onRequestClose?: () => void;
}

const FormErrorsModal = ({
  errorMessageArray = [],
  title = 'Error',
  onRequestClose = () => null,
}: FormErrorsModalProps): React.ReactElement | null => {
  if (!errorMessageArray.length) return null;
  return (
    <Modal
      accept={{
        text: 'OK',
        callback: onRequestClose,
      }}
      title={<AlertMessage>{title}</AlertMessage>}
      centerText
      showX
      onClickX={onRequestClose}
    >
      <FjPrimitives.FjFlexContainer direction="column">
        {errorMessageArray.map((errorMessage) => (
          <p key={errorMessage}>{errorMessage}</p>
        ))}
      </FjPrimitives.FjFlexContainer>
    </Modal>
  );
};

export default FormErrorsModal;
